module.exports = __webpack_public_path__ + "img/red_063.c845e577.png";